import { useNavigate } from 'react-router-dom';
import { useUpdateCastRelationship } from '../../../domains/scene/ui/hooks/useUpdateCastRelationship';
import { useSuccessPhotoCardToast } from '../../template/edit-collected-photo-cards/hooks/useSuccessPhotoCardToast';
import saveData from '../../../utils/saveData';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';
import { ROUTES } from '../../../constants/routes';

interface UseChangeCurrentCastRelationshipProps {
  castRelationshipId: string;
}

export const useChangeCurrentCastRelationship = ({
  castRelationshipId
}: UseChangeCurrentCastRelationshipProps) => {
  const navigate = useNavigate();
  const { mutateAsync: updateCastRelationship } = useUpdateCastRelationship();
  const showSuccessToast = useSuccessPhotoCardToast();

  const handleUpdateCastRelationship = async () => {
    if (!castRelationshipId) return;

    try {
      const response = await updateCastRelationship({
        castRelationshipId: castRelationshipId,
        body: {}
      });

      if (response?.castRelationshipId) {
        saveData(LOCAL_STORAGE_KEYS.CURRENT_CAST_RELATIONSHIP_ID, response.castRelationshipId);
        navigate(ROUTES.SCENE.MAIN);
        showSuccessToast('bottom', '선택한 인물조합으로 변경했어요!', true, null, true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { handleUpdateCastRelationship };
};
